<div class="bar">
    <div
        class="background"
        #background></div>
    <div
        class="handle"
        #handle></div>
</div>
